import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LstAuthModule } from '@savvaslearning/lst-auth';
import { LstLocaleModule } from '@lst/lst-locale';
import { LstLocaleModuleOptions } from '@lst/lst-locale/lib/model';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { environment } from './../../src/environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { metaReducers, reducers } from './core/core.state';
import { Locales } from './core/multi-stage-assignment-report/store/multi-stage-assignment-report.model';
import { LST_MODULE_OPTIONS } from '../app/shared/model/constants';

const lstLocaleModuleOptions: LstLocaleModuleOptions = {
    locales: Object.values(Locales),
};

@NgModule({
    declarations: [AppComponent],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        LstAuthModule.forRoot(LST_MODULE_OPTIONS),
        LstLocaleModule.forRoot(lstLocaleModuleOptions),
        EffectsModule.forRoot([]),
        StoreModule.forRoot(reducers, { metaReducers }),
        environment.production ? [] : StoreDevtoolsModule.instrument({ name: environment.appId }),
    ],
    providers: [],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    bootstrap: [AppComponent],
})
export class AppModule {}
